(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-collection"] && !Shopify.designMode) return;
  try {
    
class HomepageCollection extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
    this.addEventListener('submit', this.handleSubmit);
    if (this.hasAttribute('data-needs-hydration') && this.dataset.collectionUrl && !this.hydrated) {
      queueMicrotask(() => {
        if (!this.isConnected || this.hydrated) return;
        this.hydrated = true;
        this.update(new URLSearchParams());
      });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('submit', this.handleSubmit);
  }

  handleClick = (event) => {
    if (event.target.closest('[data-view-all]')) {
      this.expanded = true;
      this.update(new URLSearchParams(this.parameters));
      return;
    }
    const link = event.target.closest('a[data-collection-page], a.main-collection-grid__empty-link');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    this.update(new URL(link.href, window.location.origin).searchParams, true);
  };

  handleSubmit = (event) => {
    if (!event.target.matches('.facets__form')) return;
    event.preventDefault();
    const parameters = new URLSearchParams(new FormData(event.target));
    parameters.delete('page');
    this.update(parameters);
  };

  async update(parameters, scroll = false) {
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    const url = new URL(this.dataset.collectionUrl, window.location.origin);
    for (const [key, value] of parameters) {
      if ((key.startsWith('filter.') || key === 'sort_by' || key === 'page' || /^page_/.test(key)) && value !== '') {
        url.searchParams.append(/^page_/.test(key) ? 'page' : key, value);
      }
    }
    if (this.expanded) url.searchParams.delete('page');
    const nextParameters = new URLSearchParams(url.searchParams);
    const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    url.searchParams.set('section_id', this.dataset.sectionId);
    this.setAttribute('aria-busy', 'true');
    const viewAllButton = this.querySelector('[data-view-all]');
    if (viewAllButton) viewAllButton.disabled = true;
    const status = this.querySelector('[role="status"]');
    status.hidden = false;
    status.classList.add('visually-hidden');
    status.textContent = this.dataset.loading;
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) throw new Error('Collection request failed');
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      const replacement = documentFragment.querySelector('homepage-collection');
      if (!replacement?.querySelector('results-list') || replacement.dataset.sectionId !== this.dataset.sectionId) {
        throw new Error('Collection section missing');
      }
      if (this.expanded) {
        const grid = replacement.querySelector('[ref="grid"]');
        const lastPage = Number(grid?.dataset.lastPage || 1);
        for (let page = 2; page <= lastPage; page++) {
          if (controller.signal.aborted) return;
          const pageURL = new URL(url);
          pageURL.searchParams.set('page', String(page));
          const pageResponse = await fetch(pageURL, { signal: controller.signal });
          if (!pageResponse.ok) throw new Error('Collection page request failed');
          const pageDocument = new DOMParser().parseFromString(await pageResponse.text(), 'text/html');
          const pageSection = pageDocument.querySelector('homepage-collection');
          const pageGrid = pageSection?.querySelector('[ref="grid"]');
          if (!pageGrid || pageSection.dataset.sectionId !== this.dataset.sectionId) {
            throw new Error('Collection page missing');
          }
          grid.append(...pageGrid.children);
        }
        const footer = replacement.querySelector('.homepage-collection__footer');
        if (footer) footer.hidden = true;
      }
      const { morph } = await import('@theme/morph');
      if (controller.signal.aborted || !this.isConnected) return;
      const focusedId = this.contains(document.activeElement) ? document.activeElement.id : '';
      morph(this, replacement);
      this.parameters = nextParameters;
      const updatedStatus = this.querySelector('[role="status"]');
      updatedStatus.hidden = false;
      updatedStatus.textContent = this.querySelector('.products-count-wrapper')?.textContent.trim() || this.dataset.updated;
      if (focusedId) this.querySelector(`#${CSS.escape(focusedId)}`)?.focus({ preventScroll: true });
      if (scroll) this.querySelector('results-list')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (error) {
      if (controller.signal.aborted) return;
      status.classList.remove('visually-hidden');
      status.textContent = this.dataset.error;
      const link = document.createElement('a');
      url.searchParams.delete('section_id');
      link.href = url.toString();
      link.textContent = this.dataset.viewCollection;
      status.append(' ', link);
    } finally {
      if (this.controller === controller) {
        this.removeAttribute('aria-busy');
        const button = this.querySelector('[data-view-all]');
        if (button) button.disabled = false;
      }
    }
  }
}

if (!customElements.get('homepage-collection')) customElements.define('homepage-collection', HomepageCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
